import { render, staticRenderFns } from "./videoSelectorCard.vue?vue&type=template&id=cb0bde1e&scoped=true"
import script from "./videoSelectorCard.vue?vue&type=script&lang=js"
export * from "./videoSelectorCard.vue?vue&type=script&lang=js"
import style0 from "./videoSelectorCard.vue?vue&type=style&index=0&id=cb0bde1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0bde1e",
  null
  
)

export default component.exports